import type { HeadlineResponsePagedData } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { forwardSlashCheck } from '@on3/ui-lib/src/utils/forwardSlashCheck';
import { ArticleFeedArticle } from '@public/components/Headlines/ArticleFeed/ArticleFeed';
import clsx from 'clsx';
import { useRouter } from 'next/router';

import styles from './FeedList.module.scss';

interface IViewAllLinkProps {
  url: string;
  text: string;
  title?: string;
}

interface IArticleFeedProps extends HeadlineResponsePagedData {
  brand?: 'on3' | 'rivals';
  section?: string;
  viewAllLinks?: IViewAllLinkProps[];
}

export const FeedList = ({
  brand,
  list = [],
  section,
  viewAllLinks,
}: IArticleFeedProps) => {
  const router = useRouter();
  const userPathName = router.pathname === '/user/[slug]';

  return (
    <section
      className={clsx(styles.block, {
        [styles.authorUserContainer]: userPathName,
      })}
    >
      {section && (
        <header className={styles.header}>
          <h2 className={styles.heading}>{section}</h2>
          {brand && (
            <div className={styles.brand}>
              <span>From</span>
              <ServiceLogo type={brand} />
            </div>
          )}
        </header>
      )}
      <ul className={styles.feedList} data-feed-list>
        {list?.map((item, index) => (
          <li key={index}>
            <ArticleFeedArticle {...item} />
          </li>
        ))}
      </ul>
      {!!viewAllLinks?.length && (
        <footer
          className={clsx(styles.footer, {
            [styles.authorUserFooter]: userPathName,
          })}
        >
          {viewAllLinks?.map(({ text, title, url }, index) => {
            const formattedUrl = url ? forwardSlashCheck(url) : '/';

            return (
              <Link
                className={styles.footerLink}
                href={formattedUrl}
                key={index}
                title={title || text}
              >
                {text}
              </Link>
            );
          })}
        </footer>
      )}
    </section>
  );
};
